import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { TZ } from "@/lib/time/brt";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatarDataRelativa(iso: string, agoraMs?: number): string {
  const agora = agoraMs ?? Date.now();
  const data = new Date(iso).getTime();
  const diffMin = Math.round((agora - data) / 60000);
  if (diffMin < 1) return "agora";
  if (diffMin < 60) return `${diffMin} min atrás`;
  const diffH = Math.round(diffMin / 60);
  if (diffH < 24) return `${diffH}h atrás`;
  const diffD = Math.round(diffH / 24);
  if (diffD < 30) return `${diffD}d atrás`;
  const diffM = Math.round(diffD / 30);
  if (diffM < 12) return `${diffM} meses atrás`;
  return new Date(iso).toLocaleDateString("pt-BR", { timeZone: TZ });
}

export function formatarData(iso: string): string {
  return new Date(iso).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: TZ,
  });
}
